<template>
  <AdminLayout>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
      class="mb-2"
    ></v-progress-linear>
    <v-row class="gutters">
      <v-col
        v-for="tenant in tenants"
        :key="tenant.id"
        cols="12"
        md="3"
        class="d-flex flex-column"
      >
        <v-card
          max-height="200px"
          :border="tenant.id !== currentTenant"
          flat
          :color="tenant.id === currentTenant ? 'grey-lighten-4' : ''"
          @click="selectTenant(tenant.id)"
          class="fill-height pt-7 rounded"
          ><!-- toDO - dynamically check for activ tenant -->
          <v-card-text class="text-primary">
            {{ tenant.name }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-tooltip :disabled="!createDisabled" location="top">
      <template v-slot:activator="{ props }">
        <div
         
          v-bind="props"
          style="position: fixed; bottom: 16px; right: 16px"
        >
          <v-btn
            v-if="allowCreate"
            color="primary"
            size="large"
            location="bottom right"
            
            rounded
            @click="onOpenCreateTenant()"
            class="v-btn"
            :disabled="createDisabled"
          >
            <v-icon>mdi-plus</v-icon> Mandanten Anlegen
          </v-btn>
        </div>
      </template>
      <span>Maximale Anzahl an Mandanten erreicht</span>
    </v-tooltip>
    <TenantCreate :open="openCreateDialog" @close="onCloseCreateDialog" />
  </AdminLayout>
</template>

<script>
import AdminLayout from "@/layouts/Admin";
import { mapActions, mapGetters } from "vuex";
import TenantCreate from "@/components/Tenant/TenantCreate.vue";
import ApiTenantService from "@/services/api/ApiTenantService";

export default {
  name: "HomeView",
  components: {
    TenantCreate,
    AdminLayout,
  },
  data() {
    return {
      loading: false,
      openCreateDialog: false,
      tenantCountCheck: true,
    };
  },
  computed: {
    ...mapGetters({
      tenants: "tenants/tenants",
      currentTenant: "tenants/currentTenantId",
      allowCreate: "user/allowToCreateTenants",
    }),
    createDisabled() {
      return !this.tenantCountCheck;
    },
  },
  methods: {
    ...mapActions({
      select: "tenants/select",
      setTenants: "tenants/setTenants",
    }),
    async fetchTenants() {
      try {
        this.loading = true;
        const response = await ApiTenantService.getTenants(true);
        await this.setTenants(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async selectTenant(tenantId) {
      await this.select(tenantId);
      await this.$router.push({ name: "bookings" });
    },
    onOpenCreateTenant() {
      this.openCreateDialog = true;
    },
    async onCloseCreateDialog() {
      this.openCreateDialog = false;
      await this.fetchTenants();
      await this.getTenantCount();
    },
    async getTenantCount() {
      this.tenantCountCheck = await ApiTenantService.tenantCountCheck();
    },
  },
  async mounted() {
    await this.getTenantCount();
  },
};
</script>
